import { UPDATE_REPORT_TYPE_CHANGE } from 'constants/AppConstants';

// #genai Name the default export without changing its signature or callers.
export default async function updateReportsChange(reportId, requestBody, signature) {
  let URL = UPDATE_REPORT_TYPE_CHANGE.replace(':reportId', reportId);
  if (signature) {
    URL += `${URL.includes('?') ? '&' : '?'}signature=${encodeURIComponent(signature)}`;
  }
  try {
    const response = await fetch(URL, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
      skipAuthHeader: true,
    });
    const json = await response.json();
    if (response.status !== 200 && response.status !== 409) return { ok: false, status: response.status, json };
    return { ok: true, status: response.status, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
}
